export enum LocationEnum {
    LANAI = 'Sensei Lānaʻi',
    PORCUPINE_CREEK = 'Sensei Porcupine Creek',
}
